<template>
<div>

	<v-list-item>
		<v-list-item-content>
			<flag :iso="data.country" />
			<v-text-field
				class='fullwidth'
				filled
				label='Country ISO Code'
				prepend-icon='mdi-flag'
				v-model='data.country'
			></v-text-field>
			
		</v-list-item-content>
	</v-list-item>
	<v-list-item>
		<v-list-item-content>
			<v-text-field
				:rules='[v => !!v || "Country name is mandatory"]'
				class='fullwidth'
				filled
				label='Country name'
				prepend-icon='mdi-format-title'
				required
				v-model='data.title'
			></v-text-field>
		</v-list-item-content>
	</v-list-item>
	<v-list-item>
		<v-list-item-content>
			<v-text-field
				class='fullwidth'
				filled
				label='Website Link'
				prepend-icon='mdi-open-in-new'
				v-model='data.url'
			></v-text-field>
		</v-list-item-content>
	</v-list-item>
</div>
</template>

<script>
export default {
	name: 'BenefitForm',
	props: ['data'],
	computed: {
		_data: {
			get() {
				return this.data
			},
			set(value) {
				this.$emit('input', value)
			},
		},
	},
}
</script>

<style lang="scss" scoped>
</style>